import { render, staticRenderFns } from "./askdetails.vue?vue&type=template&id=389321cc&scoped=true&"
import script from "./askdetails.vue?vue&type=script&lang=js&"
export * from "./askdetails.vue?vue&type=script&lang=js&"
import style0 from "./askdetails.vue?vue&type=style&index=0&id=389321cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389321cc",
  null
  
)

export default component.exports